import { NgModule }  from '@angular/core';
import { CommonModule } from '@angular/common';

import { EditionsRoutingModule } from './editions-routing.module';
import { EditionsComponent } from './editions.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    EditionsRoutingModule,
    SharedModule
  ],
  declarations: [EditionsComponent],
  providers: []
})
export class EditionsModule { }



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/editions/editions.module.ts